// extracted by mini-css-extract-plugin
export default {"virtualBlock":"virtualBlock--y4Ur_"};